import { motion } from "framer-motion";
import { Check } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

/**
 * Dedicated marketplace "order placed" success screen (BNPL / Pay Later).
 *
 * Rendered as its own route so the success state can't be lost to a re-render/
 * remount the way a transient in-page overlay could — the customer lands here on
 * a real URL and stays put after checkout.
 */
const OrderSuccess = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: "tween", ease: "anticipate" }}
      className="flex items-center justify-center gap-10 py-24 px-5 text-center flex-col min-h-[70vh]"
    >
      <div className="max-w-2xl flex flex-col items-center justify-center gap-8">
        <div className="bg-green-500 rounded-full p-8 text-white">
          <Check size={36} />
        </div>
        <div className="text-center flex flex-col gap-2">
          <div className="text-3xl font-medium">Loan Request Sent!</div>
          <div>
            Congratulations! Your loan request has been sent successfully. Your
            order will be sent and processed after your request has been
            approved.
          </div>
        </div>
        <button
          onClick={() => navigate("/home")}
          type="button"
          className="p-2 py-3 text-center bg-deepBlue text-white px-10 ring-2 ring-deepBlue/50 rounded-xl font-medium"
        >
          <span>Go to Dashboard</span>
        </button>
      </div>
    </motion.div>
  );
};

export default OrderSuccess;
